import { render, staticRenderFns } from "./PaginationRow.vue?vue&type=template&id=4e22df10&scoped=true&"
import script from "./PaginationRow.vue?vue&type=script&lang=ts&"
export * from "./PaginationRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e22df10",
  null
  
)

export default component.exports